// extracted by mini-css-extract-plugin
module.exports = {"durgSales":"durgsales_durgSales__C3BQn","content":"durgsales_content__3mCQs","select":"durgsales_select__3l3Hi","total":"durgsales_total__8WqOh"};